<template>
  <div v-if="visible" class="flex justify-center items-center fixed bg-black bg-opacity-75 top-0 left-0 w-full h-full p-3 z-50">
    <card class="shadow-md bg-white rounded-sm p-1 max-w-2xl w-full">
      <div class="py-2 border-b border-line" v-if="info">
        {{info}}
      </div>
      <component :is="component" v-bind="props" v-on="events" />
    </card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('modal', ['visible', 'component', 'props', 'events', 'info'])
  }
}
</script>

<style>

</style>